import { AdmService } from 'src/app/shared/services/adm.service';
import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { Division } from 'src/app/shared/models/division';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pais } from 'src/app/shared/models/pais';
import { Region } from 'src/app/shared/models/region';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { ZonaVendedor } from 'src/app/shared/models/zonaVendedor';


@Component({
  selector: 'app-zonas-vendedores-dialog',
  templateUrl: './zonas-vendedores-dialog.component.html'
})
export class ZonasVendedoresDialogComponent implements OnInit {
  companias: Compania[] = [];
  salesOrgs: SalesOrg[] = [];
  regiones: Region[] = [];
  divisiones: Division[] = [];
  mensaje: number = 0;
  form: FormGroup;
  idTipo: number;
  zV: ZonaVendedor;
  codigoZVEdit: number = -1;

  constructor(private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ZonasVendedoresDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({
      id: ['', [Validators.required]],
      idCompania: ['', Validators.required],
      idSalesOrg: ['', Validators.required],
      idPais: [''],
      idDivision: ['', Validators.required],
      idRegion: ['', Validators.required],
      usuarioVendedor: ['', Validators.required],
      descripcion: ['', [Validators.required, Validators.maxLength(256)]],
      email: ['', [Validators.required, Validators.maxLength(256), Validators.email]],
      telefono1: ['', Validators.required],
      telefono2: ['', Validators.required],
      autor: [''],
      habilitacion: [true],
      codigo: [0]
    })
    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.zV != null) {
      this.codigoZVEdit = data.zV.codigo
      this.zV = data.zV

    }
  }

  public Etiquetas: {

    Habilitacion: string
    Codigo: string
    IdCompania: string
    IdSalesOrg: string
    IdDivision: string
    IdRegion: string
    UsuarioVendedor: string
    Descripcion: string
    Email: string
    Telefono1: string
    Telefono2: string
  }

  public Validaciones: {
    Compania: string
    SalesOrg: string
    Codigo: string
    IdDivision: string
    IdRegion: string
    UsuarioVendedor: string
    Descripcion: string
    Email: string
    Telefono1: string
    Telefono2: string
  }

  ngOnInit(): void {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {
      Habilitacion: this.configService.etiquetas.Habilitacion,
      Codigo: this.configService.etiquetas.Codigo,
      IdCompania: this.configService.etiquetas.Compania,
      IdSalesOrg: this.configService.etiquetas.SalesOrg,
      IdDivision: this.configService.etiquetas.Division,
      IdRegion: this.configService.etiquetas.Region,
      UsuarioVendedor: this.configService.etiquetas.ZonasVendedores.UsuarioVendedor,
      Descripcion: this.configService.etiquetas.Descripcion,
      Email: this.configService.etiquetas.Email,
      Telefono1: this.configService.etiquetas.Telefono1,
      Telefono2: this.configService.etiquetas.Telefono2,

    }

    this.Validaciones = {

      Codigo: this.configService.validaciones.Codigo,
      Compania: this.configService.validaciones.Compania,
      SalesOrg: this.configService.validaciones.SalesOrg,
      IdDivision: this.configService.validaciones.Division,
      IdRegion: this.configService.validaciones.Region,
      UsuarioVendedor: this.configService.validaciones.ZonasVendedores.UsuarioVendedor,
      Descripcion: this.configService.validaciones.Descripcion,
      Email: this.configService.validaciones.Email,
      Telefono1: this.configService.validaciones.Telefono1,
      Telefono2: this.configService.validaciones.Telefono2,

    }
    forkJoin([

      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.admService.cDivisiones(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg, this.loggedService.logged.userName),
      this.admService.cRegiones(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg),
      this.tablasService.cZonaVendedorDB(this.codigoZVEdit)

    ]).subscribe((data: [Compania[], SalesOrg[], Division[], Region[], ZonaVendedor]) => {

      if (data[0].length) {
        this.companias = data[0];
      }

      if (data[1].length) {
        this.salesOrgs = data[1];
      }
      if (data[2].length) {
        this.divisiones = data[2];
      }
      if (data[3].length) {
        this.regiones = data[3];
      }

      if (this.idTipo == 1) {
        let paisPlaceHolder: Pais = new Pais();
        paisPlaceHolder.id = this.loggedService.logged.idPais;
        paisPlaceHolder.descripcion = "";
        this.form.controls['idPais'].setValue(paisPlaceHolder.id);
        if (this.companias.length) {
          this.form.controls['idCompania'].setValue(this.companias[0].id);
        }
        if (this.salesOrgs.length) {
          this.form.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
        }

      }

      if (typeof this.zV != 'undefined') {
        if (this.codigoZVEdit != -1) {
          if (data[4] != null) {

            this.form.controls['id'].setValue(data[4].id);
            this.form.controls['idCompania'].setValue(data[4].idCompania);
            this.form.controls['idPais'].setValue(data[4].idPais);
            this.form.controls['idSalesOrg'].setValue(data[4].idSalesOrg);
            this.form.controls['habilitacion'].setValue(data[4].habilitacion);
            this.form.controls['codigo'].setValue(data[4].codigo);
            this.form.controls['autor'].setValue(data[4].autor);
            this.form.controls['idDivision'].setValue(data[4].idDivision);
            this.form.controls['idRegion'].setValue(data[4].idRegion);
            this.form.controls['descripcion'].setValue(data[4].descripcion);
            this.form.controls['usuarioVendedor'].setValue(data[4].usuarioVendedor);
            this.form.controls['email'].setValue(data[4].email);
            this.form.controls['telefono1'].setValue(data[4].telefono1);
            this.form.controls['telefono2'].setValue(data[4].telefono2);
            this.form.markAsUntouched();
            this.form.markAsPristine();
          }
        }
      }

    });
  }
  compareCompanias(compLista: any, compZV: any): boolean {
    if (typeof compLista != 'undefined' && typeof compZV != 'undefined') {

      return compLista === compZV;
    }
  }

  compareSalesOrgs(salesOrgLista: any, salesOrgZV: any): boolean {
    if (typeof salesOrgLista != 'undefined' && typeof salesOrgZV != 'undefined') {

      return salesOrgLista === salesOrgZV;
    }
  }
  compareDivisiones(divisionesLista: any, divisionesZV: any): boolean {
    if (typeof divisionesLista != 'undefined' && typeof divisionesZV != 'undefined') {

      return divisionesLista === divisionesZV;
    }
  }
  compareRegiones(regionesLista: any, regionesZV: any): boolean {
    if (typeof regionesLista != 'undefined' && typeof regionesZV != 'undefined') {

      return regionesLista === regionesZV;
    }
  }
  selectDivisiones(idDivision: any) {
    if (idDivision == "-1") {
      this.form.controls['idDivision'].reset();
    }
  }
  selectRegiones(idRegion: any) {
    if (idRegion == '-1') {
      this.form.controls['idRegion'].reset();
    }
  }

  guardarZonaVendedor() {

    switch (this.idTipo) {
      case 1:
        this.form.controls['autor'].setValue(this.loggedService.logged.userName);
        this.tablasService.aZonaVendedor(this.form.value).subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        })
        break;

      case 2:

        this.tablasService
          .mZonaVendedor(this.form.value)
          .subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
